export default __webpack_public_path__ + "static/media/pexels-skitterphoto-633850.7c18a6c7.jpg";